/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEpisode,
    JsonEpisodeFromJSON,
    JsonEpisodeFromJSONTyped,
    JsonEpisodeToJSON,
} from './JsonEpisode';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEpisode
 */
export interface ApiResultOfJsonEpisode {
    /**
     * 
     * @type {JsonEpisode}
     * @memberof ApiResultOfJsonEpisode
     */
    data?: JsonEpisode;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEpisode
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEpisode
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEpisode
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEpisode
     */
    result?: ApiResultOfJsonEpisodeResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEpisodeResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEpisodeFromJSON(json: any): ApiResultOfJsonEpisode {
    return ApiResultOfJsonEpisodeFromJSONTyped(json, false);
}

export function ApiResultOfJsonEpisodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEpisode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEpisodeFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEpisodeToJSON(value?: ApiResultOfJsonEpisode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEpisodeToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

